export default "__VITE_ASSET__DBqdbnJp__"